import { useEffect, useRef, useState } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { Autocomplete, TextField } from "@mui/material";

import IReportAvailableColumn from "../../../../../../../../../shared/contracts/IReportAvailableColumn";
import IPivotChildColumn from "../../../../../../../../../shared/contracts/IPivotChildColumn";
import useWizardReportDataContext from "../../../../../../contexts/useWizardReportData.context";
import useHelpers from "../../../../../../../../../shared/services/helpers/useHelpers.hook";



/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Jan/05/2025
 */
export default function ChildGridColumnNameRenderer(
    props: ICellRendererParams<IPivotChildColumn>
) {

    const { availableColumns, pivotData } = useWizardReportDataContext();
    const [selectedItem, setSelectedItem] = useState<IReportAvailableColumn | null>(null);

    useEffect(() => {
        if (selectedItem?.columnName !== props.node.data?.childColumnName) {
            const col = availableColumns.find(x => x.columnName === props.node.data?.childColumnName);
            if (col) {
                setSelectedItem(col)
            }
        }
    }, [props, pivotData?.childColumns])


    const handleSelectionChange = (selEvent: React.SyntheticEvent, newSelectedItem: IReportAvailableColumn | null) => {

        if (!selectedItem || !newSelectedItem || selectedItem?.columnDataType !== newSelectedItem?.columnDataType) {
            props.node.setDataValue('childColumnGroupByValue', null);
            props.node.setDataValue('childColumnFormatValue', null);
        }

        // update the description column Name
        if (!selectedItem || !newSelectedItem || selectedItem.columnDescription === props.node.data?.childColumnDescription) {
            props.node.setDataValue('childColumnDescription', newSelectedItem?.columnDescription ?? null);
        }

        // set selected item
        setSelectedItem(newSelectedItem);

        // set childColumnName
        props.node.setDataValue('childColumnName', newSelectedItem?.columnName ?? null);


        // refresh cells
        props.api.refreshCells({
            force: true, // Ensure the cell is refreshed
            rowNodes: [props.node],
            columns: [
                'childColumnName',
                // Include the dependent columns for their useEffect to detect this change
                'childColumnDescription', 'childColumnGroupByValue', 'childColumnFormatValue'
            ],
        });

        // Manually trigger onRowDataUpdated
        props.api.dispatchEvent({ type: 'rowDataUpdated' });
    };


    // ---
    return (<Autocomplete fullWidth size='small'
        options={availableColumns}
        value={selectedItem}
        onChange={handleSelectionChange}

        getOptionLabel={(option) => option?.columnDescription ?? ''}

        renderInput={(params) =>
            <TextField {...params}
                placeholder='select column...'
                sx={{
                    '& .MuiOutlinedInput-root': {
                        fontFamily: 'inherit', // Inherit font family from AG Grid
                        fontSize: 'inherit',   // Inherit font size from AG Grid
                        color: 'inherit',      // Inherit text color
                        '& fieldset': {
                            border: 'none',    // Remove border
                        },
                    },
                    '& .MuiInputBase-input': {
                        fontFamily: 'inherit', // Inherit font family
                        fontSize: 'inherit',   // Inherit font size
                        color: 'inherit',      // Inherit text color
                    },
                }}
            />}

        renderGroup={(params) => (
            <li key={params.key}>
                <ul style={{ padding: 0 }}>{params.children}</ul>
            </li>
        )}
    />);
}